import { render, staticRenderFns } from "./PublicacionLegacy.vue?vue&type=template&id=41cd3627&scoped=true"
import script from "./PublicacionLegacy.vue?vue&type=script&lang=ts"
export * from "./PublicacionLegacy.vue?vue&type=script&lang=ts"
import style1 from "./PublicacionLegacy.vue?vue&type=style&index=1&id=41cd3627&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41cd3627",
  null
  
)

export default component.exports